import { render } from "./functioniQuelaComponent.vue?vue&type=template&id=8debbcf8&scoped=true"
const script = {}

import "./functioniQuelaComponent.vue?vue&type=style&index=0&id=8debbcf8&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\HP\\Desktop\\Proyectos Vue.js\\version-produccion-iquela\\Dashboard_usuarios\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8debbcf8"]])

export default __exports__